<template>
  <div class="grid">
    <div class="col-12">
      <div class="card">
        <h1>{{ $t("cuentaYFacturacion.titulo") }}</h1>
        <div class="card">
          <TabMenu :model="cuentaYFacturacionMenu" :activeIndex.sync="active"/>
          <router-view />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import RoutesMixin from "@/utils/routes";
export default {
  name: "CuentaYFacturacion",
  mixins: [RoutesMixin],
  data() {
    return {
      active: 0,
      cuentaYFacturacionMenu: [
        {
          label: this.$t("cuentaYFacturacion.datosFacturacion.titulo"),
        },
        {
          label: this.$t("cuentaYFacturacion.datosContacto.titulo"),
        },
        {
          label: this.$t("cuentaYFacturacion.usosConsumo.titulo"),
        },
      ],
      routes: [
        "billing",
        "contact",
        "usage",
      ]
    };
  },
  created() {
    this.setTabIdx();
  },
  watch: {
    active(newValue) {
      this.to({
        name: this.routes[newValue],
        params: {
          index: newValue
        }
      })
    }
  },
  methods: {
    setTabIdx() {
      if (this.$route.params.index !== undefined) this.active = this.$route.params.index;
    },
  }
};
</script>

<style scoped>
</style>